import { frontendURL } from '../../../helper/URLHelper';
import KnowledgePage from './KnowledgePage.vue';
import IntegracoesPage from './IntegracoesPage.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/knowledge'),
    name: 'knowledge_index',
    component: KnowledgePage,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/integracoes'),
    name: 'integracoes_index',
    component: IntegracoesPage,
    meta: commonMeta,
  },
];
